// extracted by mini-css-extract-plugin
export default {"routineDefinitionCreateOrEditDialog":"routineDefinitionCreateOrEditDialog-ITRHv","structuredDataForm":"structuredDataForm-QkvaO"};